import actionTypes from './actions';
import { Card, Retrospective, User } from '../@types/domain';

export type TGlobalContent = {
  screen: string | null;
  currentRetrospectiveId: string | undefined;
  retrospective: Retrospective | undefined;
  teamMood: never[];
  cards: Card[];
  user: User | undefined;
  isLoading: boolean;
  onLoading: (isLoading: boolean) => void;
  onChangeScreen: (screen: string, screenArguments?: string) => void;
};

const {
  ON_LOADING,
  CHANGE_SCREEN,
  LOAD_RETROSPECTIVE,
  LOAD_USER,
  UPDATE_CARDS,
  UPDATE_MOODS,
  REORDER_CARDS,
  MOVE_AND_UPDATE_CARDS,
  COMBINE_CARDS,
} = actionTypes;

const reorderCards = (stateCards, payload) => {
  const { source, destination } = payload;
  const items = stateCards.filter(
    (card) => card.columnName === source.droppableId
  );
  const [removed] = items.splice(source.index, 1);
  items.splice(destination.index, 0, removed);

  const removeOldCards = stateCards.filter(
    (card) => card.columnName !== source.droppableId
  );
  return [...removeOldCards, ...items];
};

const moveCards = (stateCards, payload) => {
  const { source, destination } = payload;
  const sourceClone = stateCards.filter(
    (card) => card.columnName === source.droppableId
  );
  const destinationClone = stateCards.filter(
    (card) => card.columnName === destination.droppableId
  );
  const [removed] = sourceClone.splice(source.index, 1);
  destinationClone.splice(destination.index, 0, removed);

  // eslint-disable-next-line no-return-assign,no-param-reassign
  sourceClone.map((item) => (item.columnName = source.droppableId));
  // eslint-disable-next-line no-return-assign,no-param-reassign
  destinationClone.map((item) => (item.columnName = destination.droppableId));
  const restClone = stateCards.filter(
    (card) =>
      card.columnName !== source.droppableId &&
      card.columnName !== destination.droppableId
  );

  return [...restClone, ...sourceClone, ...destinationClone];
};

const combineCards = (stateCards, payload) => {
  const { cardIdToUpdate, cardIdToDelete, description } = payload;
  const updatedCards = stateCards.map((item) => {
    if (item.id === cardIdToUpdate) {
      return {
        ...item,
        description,
      };
    }
    return item;
  });

  return updatedCards.filter((item) => item.id !== cardIdToDelete);
};

const globalReducer = (state: TGlobalContent, action) => {
  switch (action.type) {
    case ON_LOADING: {
      return {
        ...state,
        isLoading: action.payload,
      };
    }
    case CHANGE_SCREEN: {
      return {
        ...state,
        cards: [],
        moods: [],
        screen: action.payload.screen,
        retrospective: undefined,
        currentRetrospectiveId: action.payload.retrospectiveId,
      };
    }
    case LOAD_RETROSPECTIVE: {
      return {
        ...state,
        retrospective: action.payload,
      };
    }
    case LOAD_USER: {
      return {
        ...state,
        user: action.payload,
      };
    }
    case UPDATE_CARDS: {
      return {
        ...state,
        cards: action.payload,
      };
    }
    case UPDATE_MOODS: {
      return {
        ...state,
        teamMood: action.payload,
      };
    }
    case REORDER_CARDS: {
      return {
        ...state,
        cards: reorderCards(state.cards, action.payload),
      };
    }
    case MOVE_AND_UPDATE_CARDS: {
      return {
        ...state,
        cards: moveCards(state.cards, action.payload),
      };
    }
    case COMBINE_CARDS: {
      return {
        ...state,
        cards: combineCards(state.cards, action.payload),
      };
    }

    default: {
      return state;
    }
  }
};

export default globalReducer;
